import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { styled } from '@mui/material';
import { IconButton } from 'components/IconButton';
import MediaTypography from 'components/MediaTypography';

export const StyledGoBackHeaderWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	maxHeight: 'fit-content',
	gap: '24px',
	flex: 1,
});

export const StyledGoBackHeaderButton = styled(IconButton)(({ theme }) => ({
	[theme.breakpoints.down('sm')]: {
		position: 'absolute',
	},
}));

export const StyledGoBackHeaderTitle = styled(MediaTypography)(({ theme }) => ({
	[theme.breakpoints.down('sm')]: {
		margin: '0 auto',
		paddingLeft: '36px',
		textAlign: 'center',
	},
}));

export const StyledGoBackHeaderArrowBack = styled(ArrowBackIosNewIcon)(({ theme }) => ({
	fontSize: '12px',

	[theme.breakpoints.down('sm')]: {
		fontSize: '16px',
	},
}));
